import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCommentsoldOAuthUrl = {
  name: "getCommentsoldOAuthUrl" as const,
  input: z.object({
    product: createEnum(CommentsoldIntegrationProduct),
    isStaging: z.boolean(),
    stagingEnv: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};
